import React, { useState, Fragment } from 'react';
import {
    Box, IconButton, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    Typography, Button, Dialog, DialogContent,
    DialogActions, Stack, TextField
} from '@mui/material';
import {
    AddCircleOutline, Edit, Delete, Save, Close
} from '@mui/icons-material';
import InputForm from "../../InputT";
import SearInputG from "../../SearchInput";
import CheckBox from "../../CheckBox";
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import SweetAlert from "sweetalert2";
import { Select } from 'antd';

const searchCat: ParamsPicklist = { CodeAgence: '', Table: "CategorieActif", Colonne1: "CodeCategorie", Colonne2: "Libelle", Colagence: '101', Choix: 22 };
const searchFam: ParamsPicklist = { CodeAgence: '', Table: "FamilleActif", Colonne1: "CodeFamille", Colonne2: "Libelle", Colagence: '101', Choix: 22 };

const Tab1 = (props: {
    form?: any,
    glActifs: any[],
    EtatG: boolean,
    setglActifs: React.Dispatch<React.SetStateAction<any[]>>,
    disabledForm: boolean,
    sbmit: string
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);

    const [assetForm, setAssetForm] = useState({
        CODEACTIF: '', DESIGNATION: '', COUTINITIAL: 0, VALEURRESIDUELLE: 0, LOCALISATIONCOURANTE: '', STATUT: 'EN_ACQUISITION', GRADE: 'A'
    });

    /**
     * PHASE 2 & 3 : Gestion du Panier (Staging)
     */
    const handleAddOrUpdateAsset = async () => {
        if (!assetForm.DESIGNATION) {
            SweetAlert.fire("Champs requis", "La désignation est obligatoire", "warning");
            return;
        }

        if (editingIndex !== null) {
            const updatedList = [...props.glActifs];
            updatedList[editingIndex] = assetForm;
            props.setglActifs(updatedList);
            
        } else {
            const nouvelActif = { ...assetForm, CODEACTIF: "" }; 
            props.setglActifs(prev => [...prev, nouvelActif]);
    }
    closeAssetModal();
};
        

    const openEditAsset = (index: number) => {
        setEditingIndex(index);
        setAssetForm(props.glActifs[index]);
        setIsModalOpen(true);
    };

    const deleteAssetLocal = (index: number) => {
    const assetName = props.glActifs[index]?.DESIGNATION || "cet actif";

    SweetAlert.fire({
      title: "Suppression",
      text: `Voulez-vous vraiment retirer "${assetName}" du panier ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Oui, supprimer",
      cancelButtonText: "Annuler",

      didOpen: () => {
        const confirmBtn = SweetAlert.getConfirmButton();
        const cancelBtn = SweetAlert.getCancelButton();
        if (confirmBtn) confirmBtn.style.color = 'white';
        if (cancelBtn) cancelBtn.style.color = 'white';
      }

      }).then((result) => {
      if (result.isConfirmed) {
        props.setglActifs(prev => prev.filter((_, i) => i !== index));
        
        SweetAlert.fire({
            title: "Retiré",
            text: "L'actif a été enlevé de la liste locale.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false
        });
      }
    });
  };

    const closeAssetModal = () => {
        setIsModalOpen(false);
        setEditingIndex(null);
        setAssetForm({ CODEACTIF: '', DESIGNATION: '', COUTINITIAL: 0, VALEURRESIDUELLE: 0, LOCALISATIONCOURANTE: '', STATUT: 'EN_ACQUISITION', GRADE: 'A' });
    };

    return (
        <div className='tabItem'>
            <Box className='border' width={"85%"} position={"absolute"}>
                <legend> MISE EN PLACE DES CATÉGORIES D'ACTIFS </legend>

                {/* --- CONFIGURATION MAITRE --- */}
                <Box style={{ marginTop: -10, display: 'flex', width: '100%' }}>
                    <fieldset className="bordure1">
                        <Box style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                            {/* CODE CATEGORIE : Pivot de recherche (Phase 1) ou bloqué (Phase 3) */}
                            <Box sx={{ pointerEvents: props.sbmit === 'add' ? 'none' : 'auto', display: 'inline-block' }}>
                                <SearchModal disabled={props.EtatG} notRequired form={props.form} width={4} Titre={'Recherche Catégorie'} label={'Code Catégorie'} name={'CODECATEGORIE'} Parametre={searchCat} />
                            </Box>

                            <InputForm label="Libellé" type="texte" name="LIBELLE" rules={[{ pattern: /^[a-zA-Z0-9\sÀ-ÿ]*$/, message: "Caractères spéciaux non autorisés" }]} taille={250} disabled={props.disabledForm} />

                            {/* FAMILLE : Grisée par défaut (Phase 1), Verrouillage via pointerEvents car pas de prop disabled */}
                            <Box sx={{ pointerEvents: props.disabledForm ? 'none' : 'auto', display: 'inline-block' }}>
                                <SearInputG form={props.form} width={4} Titre={'Recherche Famille'} label={'Famille'} name={'FAMILLE'} Parametre={searchFam} dissabledCode={props.disabledForm} />
                            </Box>

                            <InputForm label="Règles d'usage" type="TextArea" name="REGLESUSAGE" rules={[{ pattern: /^[a-zA-Z0-9\sÀ-ÿ]*$/, message: "Caractères spéciaux non autorisés" }]} taille={400} disabled={props.disabledForm} />

                            <Box display="flex" gap={2} alignItems="center">
                                {/* ADAPTATION CHECKBOX : Passage du form obligatoire pour éviter l'erreur undefined */}
                                <CheckBox notRequired form={props.form} label="Licite" name="ESTLICITE" disabled={props.disabledForm} />
                                <CheckBox notRequired form={props.form} label="Actif" name="ESTACTIF" disabled={props.disabledForm} />
                            </Box>
                        </Box>
                    </fieldset>
                </Box>

                {/* --- TABLE DES ACTIFS (PANIER LOCAL) --- */}
                <Box style={{ width: '100%', marginTop: '20px' }}>
                    <fieldset className="bordure1">
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} px={1}>
                            <Box>
                                <Typography sx={{ fontWeight: 800, color: '#0d4a70', textTransform: 'uppercase', fontSize: 13 }}>Inventaire des actifs</Typography>
                                <Typography variant="caption" sx={{ color: '#116599', fontWeight: 'bold' }}>Total panier : {props.glActifs.length}</Typography>
                            </Box>
                            <Button
                                variant="contained" size="small" startIcon={<AddCircleOutline />}
                                disabled={props.disabledForm}
                                onClick={() => setIsModalOpen(true)}
                                sx={{ bgcolor: "#116599", cursor: props.disabledForm ? 'not-allowed' : 'pointer' }}
                            >
                                Ajouter un actif
                            </Button>
                        </Box>

                        <TableContainer component={Paper} elevation={3} sx={{ maxHeight: 350 }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ color: '#fff', bgcolor: "#116599", fontWeight: "bold" }}>Code Actif</TableCell>
                                        <TableCell sx={{ color: '#fff', bgcolor: "#116599", fontWeight: "bold" }}>Désignation</TableCell>
                                        <TableCell sx={{ color: '#fff', bgcolor: "#116599", fontWeight: "bold" }}>Grade</TableCell>
                                        <TableCell sx={{ color: '#fff', bgcolor: "#116599", fontWeight: "bold" }}>Statut</TableCell>
                                        <TableCell sx={{ color: '#fff', bgcolor: "#116599", fontWeight: "bold" }} align="center">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.glActifs.map((a, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell sx={{ fontWeight: 'bold' }}>{a.CODEACTIF || <span style={{ color: 'gray', fontStyle: 'italic' }}>En attente...</span>}</TableCell>
                                            <TableCell>{a.DESIGNATION}</TableCell>
                                            <TableCell><b style={{ color: '#116599' }}>{a.GRADE}</b></TableCell>
                                            <TableCell><span style={{ color: '#116599', fontWeight: 'bold' }}>{a.STATUT}</span></TableCell>
                                            <TableCell align="center">
                                                <Stack direction="row" spacing={0.5} justifyContent="center">
                                                    <IconButton size="small" color="primary" onClick={() => openEditAsset(index)} disabled={props.disabledForm}>
                                                        <Edit sx={{ fontSize: 18 }} />
                                                    </IconButton>
                                                    <IconButton size="small" color="error" onClick={() => deleteAssetLocal(index)} disabled={props.disabledForm}>
                                                        <Delete sx={{ fontSize: 18 }} />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {props.glActifs.length === 0 && (
                                        <TableRow><TableCell colSpan={6} align="center">Panier vide</TableCell></TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </fieldset>
                </Box>
            </Box>

            {/* MODALE D'ACTIF */}
            <Dialog open={isModalOpen} onClose={closeAssetModal} maxWidth="sm" fullWidth>
                <Box sx={{ bgcolor: '#116599', p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography color="white" fontWeight="bold">Saisie Actif Physique</Typography>
                    <IconButton onClick={closeAssetModal} size="small" sx={{ color: 'white' }}><Close /></IconButton>
                </Box>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <TextField disabled label="Code Actif" fullWidth size="small" value={assetForm.CODEACTIF || "Automatique..."} />
                        <TextField label="Désignation" fullWidth size="small" value={assetForm.DESIGNATION} onChange={e => setAssetForm({ ...assetForm, DESIGNATION: e.target.value })} />
                            <Box sx={{ minWidth: 120, mt: 1 }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#666' }}>Grade de l'actif</Typography>
                                <Select
                                    style={{ width: '100%' }}
                                    value={assetForm.GRADE}
                                    onChange={(val) => setAssetForm({ ...assetForm, GRADE: val })}
                                    options={[
                                        { value: 'A', label: 'Grade A (Neuf)' },
                                        { value: 'B', label: 'Grade B (Excellent état)' },
                                        { value: 'C', label: 'Grade C (Bon état)' },
                                        { value: 'D', label: 'Grade D (État moyen)' },
                                        { value: 'E', label: 'Grade E (Mauvais état)' },
                                        { value: 'F', label: "Grade F (Hors d'usage)" },
                                    ]}
                                    />
                            </Box>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#f8f9fa' }}>
                    <Button variant="contained" sx={{ bgcolor: "#116599" }} startIcon={<Close />} onClick={closeAssetModal}>Annuler</Button>
                    <Button variant="contained" sx={{ bgcolor: "#116599" }} startIcon={<Save />} onClick={handleAddOrUpdateAsset}>Valider</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Tab1;